import { loanApplicationsApi, loanApplicationsProgressApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';

export const LOAN_SUMMARY_ACTION_TYPE = {
  GET_SUMMARY: 'GET_SUMMARY',
};

export const getLoanSummaryAction = catchAsyncActionError(params => async dispatch => {
  const [loanSummary, loanProgress] = await Promise.all([
    loanApplicationsApi.getLoanSummary(params),
    loanApplicationsProgressApi.getApplicationProgress(params),
  ]);

  const data = {
    ...loanSummary?.data,
    loanProgress: loanProgress?.data,
  };

  return dispatch({
    type: LOAN_SUMMARY_ACTION_TYPE.GET_SUMMARY,
    payload: data,
  });
});
